import classes from "./Card.module.css"
import {Box, Spacer, VStack} from "@chakra-ui/react";

/**
 * This represents the layout for a single NFT Item
 */
function Card(props) {
    return (
        <VStack className={classes.card} width={props.width} height={props.height} backgroundColor={"terminal.background"}>
            <Box className={classes.cardTop}>
            </Box>

            {props.children}

            <Spacer />
            <Box className={classes.cardBottom}>
            </Box>
        </VStack>
    )
}

export default Card;